const premadeLogos = {
  BABYLON: {
    src: '/images/babylon.png',
    alt: 'Babylon logo',
  },
  ASK_A_AND_E: {
    src: '/images/GBR/AskAandE/ask-a-and-e.png',
    alt: 'Ask A&E logo',
  },
}

export default premadeLogos
